"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationSummaryPriceBlock = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
require("./index.scss");
const ReservationSummaryPriceBlock = (props) => {
    const { id, title, priceItems, } = props;
    if (!priceItems)
        return null;
    return (react_1.default.createElement("div", { className: `${__1.className}__block` },
        react_1.default.createElement("h4", { className: `${__1.className}__subtitle` }, title),
        react_1.default.createElement("div", { className: `${__1.className}__block-content` }, priceItems.map((priceItem, index) => (react_1.default.createElement("div", { className: `${__1.className}-price-block`, key: `rs-PriceItem::${id}:${index}` },
            react_1.default.createElement("div", { className: `${__1.className}-price-block__price-item-label` }, priceItem.labelText),
            react_1.default.createElement("div", { className: `${__1.className}-price-block__price-item-price` }, priceItem.priceText)))))));
};
exports.ReservationSummaryPriceBlock = ReservationSummaryPriceBlock;
//# sourceMappingURL=index.js.map